import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export const getOffers = (state: RootState) => state.offers.data;

export const getActiveOffers = createSelector(getOffers, (offers) =>
  offers.filter((offer) => offer.isActive)
);
